import { isCraDevLocalProxy } from "./ApiBaseUrl";

const GeoService = {
    /**
     * Detects if the user is in Quebec based on their IP address
     * @returns {Promise<boolean>} True if user is in Quebec, false otherwise
     */
    isQuebec: async () => {
        try {
            // CRA dev: proxied path. Capacitor / production: absolute URL (relative would hit https://localhost/...).
            const geoUrl = isCraDevLocalProxy()
                ? "/get.geojs.io/v1/ip/geo.json"
                : "https://get.geojs.io/v1/ip/geo.json";
            const response = await fetch(geoUrl);
            const data = await response.json();
            
            // Check if user is in Quebec (region code QC or province Quebec)
            const isQuebec = data.region === 'QC' || 
                           data.region === 'Quebec' || 
                           data.province === 'Quebec' ||
                           data.province === 'QC';
            
            return isQuebec;
        } catch (error) {
            console.error("Error detecting region:", error);
            // Return false (default to English) if detection fails
            return false;
        }
    },

    /**
     * Gets the default language based on user's region
     * @returns {Promise<string>} 'french' for Quebec, 'english' for others
     */
    getDefaultLanguage: async () => {
        const isQuebec = await GeoService.isQuebec();
        return isQuebec ? 'french' : 'english';
    }
};

export default GeoService;

